//
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
import { writable } from 'svelte/store'

/**
 * "Reader mode" for Markdown files: a rendered, read-only view instead of the source text. This is only the DEFAULT
 * (the checkbox in the file panel can still switch it for the file that is open). It lives here, next to the language
 * and theme switches of the settings popup, which is where it is changed.
 *
 * Stored in the browser: without a stored value it is ON.
 */
const KEY = 'huly:markdownReaderMode'

export function parseReaderMode (stored: string | null | undefined): boolean {
  return stored !== 'off'
}

function load (): boolean {
  try {
    return parseReaderMode(localStorage.getItem(KEY))
  } catch {
    return true // storage blocked: keep the default
  }
}

export const markdownReaderDefault = writable<boolean>(load())

export function setMarkdownReaderDefault (on: boolean): void {
  markdownReaderDefault.set(on)
  try {
    localStorage.setItem(KEY, on ? 'on' : 'off')
  } catch {
    // storage blocked: the choice only lasts until the page is reloaded
  }
}
